import { getClassroomApiUrl } from "js/utils/getBackendUrl";
import * as clsApi from "js/api/classroomApi";

export type RemoveStudentFromClassroomRequestPayload = {
	teacherId: string;
	classStableId?: string; // Used if the classroom is not a group
	groupStableId?: string; // Used if the classroom is a group
	studentStableId: string;
	studentUserName: string;
};

export async function addStudentToClassroom(
	teacherId: string,
	studentUuid: string,
	classroomOrGroupUuid: string,
	classroomType: "classroom" | "group",
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(
		`${host}/v1/devices/${authHeaders.Device}/${classroomType}s/${classroomOrGroupUuid}/students/${studentUuid}`,
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				user: teacherId,
				Authorization: authHeaders.Authorization,
				Device: authHeaders.Device,
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to add student to classroom: ${response.status}`);
	}
}

export async function removeStudentFromClassroom(
	teacherId: string,
	studentUuid: string,
	studentStableId: string, // Needed to un-focus the student because focus uses stableIds.
	studentUsername: string, // Needed to un-pause the student because pause uses usernames.
	classroomType: "classroom" | "group",
	classroomOrGroupUuid: string,
	classroomOrGroupStableId: string,
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const requestPayload: RemoveStudentFromClassroomRequestPayload = {
		teacherId: teacherId,
		studentStableId: studentStableId,
		studentUserName: studentUsername,
	};

	if (classroomType === "classroom") {
		requestPayload.classStableId = classroomOrGroupStableId;
	} else if (classroomType === "group") {
		requestPayload.groupStableId = classroomOrGroupStableId;
	}

	const response = await fetch(
		`${host}/v1/devices/${authHeaders.Device}/${classroomType}s/${classroomOrGroupUuid}/students/${studentUuid}`,
		{
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				user: teacherId,
				Authorization: authHeaders.Authorization,
				Device: authHeaders.Device,
			},
			body: JSON.stringify(requestPayload),
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to remove student from classroom: ${response.status}`);
	}
}
